// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Label/Label.sass
// module id = 424
// module chunks = 0